(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const getResultMapHandler = svs.lyckoplatsen.components.shared_map.getResultMapHandler;
const getHomeLocationCoordinates = svs.tur.lyckoplatsen.map.getHomeLocationCoordinates;
const PinIcon = svs.lyckoplatsen.shared_utils.react.components.PinIcon;
const Button = svs.ui.ReactButton;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom,
  useSetAtom = _jotai.useSetAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  selectedHighlightedWinGroupAtom = _svs$lyckoplatsen$com.selectedHighlightedWinGroupAtom,
  showHomeLocationPinAtom = _svs$lyckoplatsen$com.showHomeLocationPinAtom;
const mapErrorDialogNoRedirect = svs.lyckoplatsen.shared_map.utils.mapErrorDialogNoRedirect;
const MapSingle = _ref => {
  let _ref$mapId = _ref.mapId,
    mapId = _ref$mapId === void 0 ? 'map-single-pin' : _ref$mapId,
    _ref$wagers = _ref.wagers,
    wagers = _ref$wagers === void 0 ? null : _ref$wagers,
    result = _ref.result,
    _ref$results = _ref.results,
    results = _ref$results === void 0 ? null : _ref$results,
    _ref$showHomeLocation = _ref.showHomeLocationButton,
    showHomeLocationButton = _ref$showHomeLocation === void 0 ? false : _ref$showHomeLocation;
  const mapHandlerResult = useMemo(() => getResultMapHandler(), []);
  const mapResults = useMemo(() => {
    if (Array.isArray(results)) {
      return results.filter(Boolean);
    }
    return [results || result].filter(Boolean);
  }, [results, result]);
  const mapPrimaryResult = result || mapResults[0];
  const hasMultipleResults = mapResults.length > 1;
  const _useAtom = useAtom(selectedHighlightedWinGroupAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    highlightedWinGroup = _useAtom2[0],
    setHighlightedWinGroup = _useAtom2[1];
  const correctionStep = useAtomValue(correctionStepAtom);
  const showHomeLocationPin = useAtomValue(showHomeLocationPinAtom);
  const setShowHomeLocationPin = useSetAtom(showHomeLocationPinAtom);
  const shouldCenterSelectedResult = highlightedWinGroup !== null || !hasMultipleResults;
  const hasHomeLocation = useMemo(() => Boolean(getHomeLocationCoordinates()), []);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCenterWagersButton = _useState2[0],
    setShowCenterWagersButton = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCenterWinCircleButton = _useState4[0],
    setShowCenterWinCircleButton = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    mapCenter = _useState6[0],
    setMapCenter = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    circlesReady = _useState8[0],
    setCirclesReady = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    mapReady = _useState0[0],
    setMapReady = _useState0[1];
  const winGroupClass = highlightedWinGroup || highlightedWinGroup === 0 ? "lp-wingroup-".concat(highlightedWinGroup) : '';
  const handleHomeLocationClick = () => {
    if (showHomeLocationPin) {
      setShowHomeLocationPin(false);
      mapHandlerResult.removeHomeLocation();
      return;
    }
    setShowHomeLocationPin(true);
    mapHandlerResult.showHomeLocation();
  };
  const handleCenterWinCircleClick = () => {
    setMapCenter(true);
    mapHandlerResult.centerWinCircle();
    if (highlightedWinGroup !== null) {
      setHighlightedWinGroup(null);
    }
  };
  const handleCenterWagersClick = () => {
    setMapCenter(false);
    mapHandlerResult.centerWagers();
    setHighlightedWinGroup(null);
  };

  useEffect(() => {
    setCirclesReady(false);
    const mapOptions = {
      nodeId: mapId,
      geoJsonInv: true,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      dragging: true,
      boxZoom: true,
      touchZoom: true,
      showErrorOverlay: false,
      zoomControl: false,
      showCenterButton: true,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      highlightedWinGroup: index => setHighlightedWinGroup(index),
      showCenterWagersButton: bool => setShowCenterWagersButton(bool),
      showCenterWinCircleButton: bool => setShowCenterWinCircleButton(bool),
      resultRendered: () => {
        setCirclesReady(true);
      }
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    setMapReady(true);
    return () => {
      setMapReady(false);
      mapHandlerResult.removeMap();
    };
  }, [mapHandlerResult, mapId, setHighlightedWinGroup, mapResults]);
  useEffect(() => {
    if (!mapReady) {
      return;
    }
    if (showHomeLocationPin) {
      mapHandlerResult.showHomeLocation({
        panToLocation: false
      });
    } else {
      mapHandlerResult.removeHomeLocation();
    }
  }, [mapHandlerResult, mapReady, showHomeLocationPin, mapPrimaryResult]);
  useEffect(() => {
    if (mapResults.length && correctionStep) {
      mapResults.slice().reverse().forEach(mapResult => {
        const winGroups = mapResult.distribution;
        const winningLocation = mapResult.location;
        mapHandlerResult.showResult({
          winGroups,
          winningLocation
        });
      });
    }
    if (!correctionStep) {
      mapHandlerResult.fitBoundsSweden();
    }
  }, [correctionStep, mapHandlerResult, mapResults]);
  useEffect(() => {
    if (wagers) {
      mapHandlerResult.showWagers(wagers, mapPrimaryResult);
      return () => mapHandlerResult.removeWagers();
    }
  }, [mapHandlerResult, wagers, mapPrimaryResult]);


  useEffect(() => {
    if (!mapCenter && highlightedWinGroup !== null && highlightedWinGroup !== 'zoomed') {
      setMapCenter(true);
    }
  }, [highlightedWinGroup, mapCenter]);
  useEffect(() => {
    if (highlightedWinGroup === 0) {
      mapHandlerResult.selectSinglePin();
      mapHandlerResult.moveToWinGroup(0);
      return () => mapHandlerResult.clearSelectedSinglePin();
    }
    if (highlightedWinGroup === 'zoomed') {
      mapHandlerResult.moveToWinGroup(0, true);
    } else if (shouldCenterSelectedResult && mapPrimaryResult && correctionStep && circlesReady && mapCenter) {
      mapHandlerResult.moveToWinGroup(highlightedWinGroup);
    }
  }, [correctionStep, highlightedWinGroup, mapHandlerResult, mapPrimaryResult, circlesReady, mapCenter, shouldCenterSelectedResult]);

  useEffect(() => {
    if (hasMultipleResults && correctionStep && circlesReady) {
      mapHandlerResult.fitResultBounds({
        includeWagers: Boolean(wagers)
      });
      return;
    }
    if (wagers && correctionStep && circlesReady) {
      mapHandlerResult.centerWagers();
    }
  }, [correctionStep, mapHandlerResult, circlesReady, wagers, hasMultipleResults]);
  return React.createElement("div", {
    className: "result-map ".concat(winGroupClass, " ").concat(wagers ? 'has-wagers' : '')
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), correctionStep !== 0 && React.createElement(Button, {
    disabled: !showCenterWinCircleButton,
    className: "lp-btn-center-map ".concat(showCenterWinCircleButton ? '' : 'disable'),
    onClick: handleCenterWinCircleClick
  }, React.createElement(PinIcon, {
    color: "green"
  })), wagers && React.createElement(Button, {
    disabled: !showCenterWagersButton,
    className: "lp-btn-center-wagers ".concat(showCenterWagersButton ? '' : 'disable'),
    onClick: handleCenterWagersClick
  }, React.createElement(PinIcon, {
    color: "red"
  })), showHomeLocationButton && hasHomeLocation && React.createElement(Button, {
    className: "lp-btn-home-location",
    onClick: handleHomeLocationClick,
    "aria-pressed": showHomeLocationPin,
    "aria-label": "Visa hemadress"
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/hemma.svg"),
    alt: ""
  })));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapSingle
});

 })(window);